import { EmployeeResponse, EmployeesResponse, ExpenseCategoriesResponse, ExpenseCategoryResponse, ExpenseEntryResponse, ExpensesResponse, PayrollResponse, VoidExpenseResponse, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/expenses` — a folha dos funcionários e o caderno de gastos (F146).
 *
 * A loja vai pela sessão (a filial escolhida no topo), como na comissão.
 */
const withSignal = (signal) => (signal ? { signal } : {});
/**
 * A query string do caderno de gastos — F187.
 *
 * Exportada e com teste próprio (`expense-params.test.ts`) pela lição da F182:
 * o filtro que existe na tela, no contrato e na rota, e **não** nesta função, é
 * um filtro mudo — acende, não filtra, e o compilador não vê. Aconteceu com
 * `brand` no Estoque e com cinco filtros em Produtos.
 */
export const expenseParams = (input) => {
    const params = new URLSearchParams({ period: input.period });
    const put = (key, value) => {
        if (value !== undefined)
            params.set(key, String(value));
    };
    put('branchId', input.branchId);
    put('search', input.search);
    put('categoryId', input.categoryId);
    put('employeeId', input.employeeId);
    put('paymentSource', input.paymentSource);
    put('status', input.status);
    put('kind', input.kind);
    put('page', input.page);
    put('pageSize', input.pageSize);
    put('sort', input.sort);
    put('direction', input.direction);
    return `?${params.toString()}`;
};
export const fetchExpenses = async (input, signal) => ExpensesResponse.parse(await request(`/api/v1/expenses/entries${expenseParams(input)}`, withSignal(signal)));
export const fetchPayroll = async (period, signal) => PayrollResponse.parse(await request(`/api/v1/expenses/payroll?${new URLSearchParams({ period }).toString()}`, withSignal(signal)));
export const recordExpense = async (input) => ExpenseEntryResponse.parse(await request('/api/v1/expenses/entries', { method: 'POST', body: input }));
export const voidExpense = async (id, input) => VoidExpenseResponse.parse(await request(`/api/v1/expenses/entries/${id}/void`, {
    method: 'POST',
    body: input,
}));
export const fetchEmployees = async (period, signal) => EmployeesResponse.parse(await request(`/api/v1/expenses/employees?${new URLSearchParams({ period }).toString()}`, withSignal(signal)));
export const createEmployee = async (input) => EmployeeResponse.parse(await request('/api/v1/expenses/employees', {
    method: 'POST',
    body: input,
}));
export const updateEmployee = async (id, input) => EmployeeResponse.parse(await request(`/api/v1/expenses/employees/${id}`, {
    method: 'PATCH',
    body: input,
}));
export const fetchExpenseCategories = async (signal) => ExpenseCategoriesResponse.parse(await request('/api/v1/expenses/categories', withSignal(signal)));
export const createExpenseCategory = async (input) => ExpenseCategoryResponse.parse(await request('/api/v1/expenses/categories', {
    method: 'POST',
    body: input,
}));
export const updateExpenseCategory = async (id, input) => ExpenseCategoryResponse.parse(await request(`/api/v1/expenses/categories/${id}`, {
    method: 'PATCH',
    body: input,
}));
/** Um bônus ou desconto que vale só naquele mês da folha (F157). */
export const recordPayrollAdjustment = async (input) => {
    await request('/api/v1/expenses/adjustments', { method: 'POST', body: input });
};
export const voidPayrollAdjustment = async (id, input) => {
    await request(`/api/v1/expenses/adjustments/${id}/void`, {
        method: 'POST',
        body: input,
    });
};
//# sourceMappingURL=expenses.js.map